import { useChatStore } from '../../store/chat';
import { useAutoScroll } from '../../hooks/useAutoScroll';
import { ChatHeader } from './ChatHeader';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';

export function ChatPane({ onBack }: { onBack?: () => void }) {
  const messageCount = useChatStore((s) => s.messages.length);
  const { bottomRef, showPill, scrollToBottom } = useAutoScroll(messageCount);

  return (
    <div className="flex-1 flex flex-col min-w-0 wa-doodle-bg relative">
      <ChatHeader onBack={onBack} />

      {/* Fixa sob o header (não rola junto com a lista) e some sozinha ao chegar embaixo. */}
      {showPill && (
        <button
          onClick={scrollToBottom}
          aria-label="Rolar para novas mensagens"
          style={{ top: 'calc(56px + env(safe-area-inset-top) + 8px)' }}
          className="wa-pill-enter absolute left-1/2 -translate-x-1/2 bg-white text-[#075E54] text-[13px] font-medium rounded-[20px] px-4 py-1 shadow-[0_1px_3px_rgba(0,0,0,0.15)] z-20"
        >
          &#8595; novas mensagens
        </button>
      )}

      <MessageList bottomRef={bottomRef} />
      <MessageInput />
    </div>
  );
}
